import { Dimensions, StyleSheet } from "react-native";

/* Styles for all PopUps */

const style = StyleSheet.create({
  fontFamily: "Open Sans",

  caixaPopUp: {
    display: "flex",
    height: "60%",
    width: "80%",
    borderColor: "#009499",
    borderStyle: "solid",
    borderWidth: 4,
    borderRadius: 5,
  },
  modalOutBackground: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(0,0,0,0.5)",
    width:'100%',
    height:'100%',
  },
  backgroundImatges: {
    flex: 1,
    resizeMode: "cover",
    justifyContent: "center",
    paddingBottom: 15,
    alignItems: "center",
  },

  cross: {
    height: 30,
    width: 30,
  },
  bafarada: {
    resizeMode: "contain",
    width: "100%",
    height: "20%",
  },
  TouchableSatisfaccio: {
    width: "100%",
    height: "20%",
  },
  ImgSatisfaccio: {
    resizeMode: "contain",
    width: "100%",
    height: "90%",
  },

  popUpTitleInicial: {
      fontSize: "4vh",
      color: "#009499",
      textAlign: "center",
      justifyContent: "center",
      alignItems: "center",
      fontFamily: "Leckerli One",
      textShadow: "-0.5vh -0.5vh 0.5vh #f2eed7, 0.5vh -0.5vh 0.5vh #f2eed7, -0.5vh 0.5vh 0.5vh #f2eed7, 0.5vh 0.5vh 0.5vh #f2eed7"
  },

  popUpMapaText: {
    color: "#6360a7",
    fontSize: "4vh",
      color: "#009499",
      textAlign: "center",
      justifyContent: "center",
      alignItems: "center",
      fontFamily: "Leckerli One",
      textShadow: "-0.5vh -0.5vh 0.5vh #f2eed7, 0.5vh -0.5vh 0.5vh #f2eed7, -0.5vh 0.5vh 0.5vh #f2eed7, 0.5vh 0.5vh 0.5vh #f2eed7",
    width: "90%",
    alignSelf: "center",
  },

  descriptionContainerHistoria: {
    flex:40,
    width: "80%",
    textAlign: "center",
    alignSelf: 'center',
    fontFamily: 'OpenSans',
    fontSize: "2.5vh",
    // color: "#3d342a"
},
  imageFlag: {
    resizeMode: "contain",
    alignSelf: "center",
    justifyContent: "center",
    width: "50%",
    height: "50%",
    marginTop: 15,
    marginBottom: 15,
  },
  xarxesContainer: {
    flex: 10,
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    // backgroundColor:'black',
    width: "100%",
    height: "100%",
  },

  popUpMapaImatge: {
    width: "80%",
    height: "100%",
    resizeMode: "contain",
    alignSelf: "center",
  },
  imatgePremiPrefil: {
    borderColor: "#009499",
    width: "100%",
    height: "100%",
    resizeMode: "contain",
  },
  textPerfil : 
  {
    color: "white",
    fontSize: "2.2vh",
    fontWeight: "bold",
    textAlign: "center",
  },
  container: {
    flex: 1,
    width: '100%',
    height: '100%'
  },

  imageBackground: {
    flex: 1,
    justifyContent: "center",
  },
  difuminat:{
    backgroundColor: 'rgba(255, 255, 255, 0.4)',
    opacity:0.3,
  },
  text: {
    color: "black",
    fontSize: 20,
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: 10,
  },
  
  titol: {
    fontFamily: 'Lobster',
    fontSize: 21,
    textAlign: "center",
    paddingTop: 0,
    paddingBottom: 10,
    fontSize: 36,
  },
  nom: {
    // color: "white",
    textAlign: "center",
    paddingTop: 9,
    paddingBottom: 15,
    //  color: "white",
    fontWeight: 600,
    fontSize: 18,
    fontFamily: 'OpenSans',
  },
  puntsText: {
    // color: "white",
    textAlign: "center",
    //   color: "black",
    fontWeight: 700,
    fontSize: 17,
    alignSelf: 'center',
    fontFamily: 'OpenSans'
  },
  text1: {
    // color: "white",
    fontSize: 20,
    textAlign: "center",
    color: "white",
    lineHeight: 1,
    fontFamily: 'OpenSans'
  },
  text2: {
    fontSize: 60,
    fontWeight: "bold",
    textAlign: "center",
    // color: "white",
    paddingTop: 0,
    paddingBottom: 5,
    fontFamily: 'OpenSans'
  },
  icona: {
    width: 50,
    height: 50,
    //  marginLeft: 15, 
    marginBottom: -15,
    resizeMode: "stretch"
  },
  noAconseguit: {
    backgroundColor: 'rgba(255, 255, 255, 0.4)',
    height: (Dimensions.get('screen').height * (13 / 15) * 0.67) * 0.15,
    width: (Dimensions.get('screen').height * (13 / 15) * 0.67)  * 0.15,
    resizeMode: 'contain', 
    //alignSelf:'center',
    paddingVertical: 10,
    paddingHorizontal: 20,

  },
  aconseguit: {
    flexDirection: 'row',
    height: (Dimensions.get('screen').height * (13 / 15) * 0.67) * 0.15,
    width: (Dimensions.get('screen').height * (13 / 15) * 0.67)  * 0.15,
    resizeMode: 'contain',
    //alignSelf:'center',
    paddingVertical: 20,
    paddingHorizontal: 20,
  },
    superPremiImg: {
    flexDirection: 'row',
    height: (Dimensions.get('screen').height * (13 / 15) * 0.67) * 0.5,
    width: (Dimensions.get('screen').height * (13 / 15) * 0.67)  * 0.45,
    resizeMode: 'contain',
    paddingVertical: 20,
    paddingHorizontal: 20,
    resizeMode: 'contain',
  },
  imatgeClick: {
    height: (Dimensions.get('screen').height * (13 / 15) * 0.67) * 0.5,
    width: (Dimensions.get('screen').height * (13 / 15) * 0.67)  * 0.6,
    alignSelf: 'center',
    resizeMode: 'contain',
  },
  caixaOut: {
    marginHorizontal: '10%',
    borderRadius: 10,
    flex: 1
  },
  caixa: {
    flex: 1,
    marginHorizontal: 10,
    marginVertical: 10,
  },
  caixaBorderContenidor: {
    borderWidth: 3,
    borderRadius: 10,
  },
  modalContent: {
    backgroundColor: "white",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    borderColor: "rgba(0, 0, 0, 0.1)",
    justifyContent: 'center',
    alignSelf: 'center',
    backgroundColor: 'red',
  },
  header: {
    color: 'white',
    backgroundColor: '#333',
    textAlign: 'center',
    position: 'relative',
    height: '50',
  },
  textImatge:{
     fontSize: '1.1rem' ,
     alignSelf:'center',
     fontWeight:'bold',
     width:'100%',  
     justifyContent:'center',
     alignItems:'center',
        textAlign:'center',
    color:'white',
     paddingTop:10 },


////////////////////ESTARNIN//////////////////

caixetiEstarnin:{
  paddingHorizontal:1,
  paddingTop:5,
  paddingBottom:15,
  borderRadius:10,
  marginHorizontal:5
},
imatgesEstarnin:{
  backgroundColor: 'white',
  width: 65,
  height: 65,
  paddingHorizontal: 20,
  borderRadius:10
},
imatgesEstarniNoAconseguit:{
  backgroundColor: 'rgba(255, 255,255, 0.7)',
  width: 65,
  height: 65,
  paddingHorizontal: 20,
  borderRadius:10,
  opacity:0.8
},
rodonaPunts:{ 
  borderRadius:300,
  paddingHorizontal:10,
  paddingVertical:10,
  backgroundColor:'red',
  color: "white",
},

SobreClick: {
  width: 300,
  height: 300,
  alignSelf: 'center',
  resizeMode: 'contain',
},

});

export default style;